import axios, { AxiosResponse } from 'axios';

import {
  DTRRule,
  DTRRules,
  DutyCalculationCodes
} from '../../components/admin-portal/Tables/Settings/DTRRules/types';

import {
  ADMIN_SETTINGS_DTR_RULES,
  ADMIN_SETTINGS_DUTY_CALCULATION_CODES
} from '../endpoints';

export const getDTRRules = () =>
  axios.get<DTRRules, AxiosResponse<DTRRules>>(ADMIN_SETTINGS_DTR_RULES);

export const getDTRRule = (dtrRuleId: number) =>
  axios.get<DTRRule, AxiosResponse<DTRRule>>(
    `${ADMIN_SETTINGS_DTR_RULES}/${dtrRuleId}`
  );

export const editDTRRule = (data: DTRRule) =>
  axios.put(`${ADMIN_SETTINGS_DTR_RULES}/${data.dtrRuleId}`, data);

export const getDutyCalculationCodes = () =>
  axios.get<DutyCalculationCodes[]>(ADMIN_SETTINGS_DUTY_CALCULATION_CODES);
